<template>
	<div class="index">
		<van-nav-bar
			title="筛选客户"
			left-text="返回"
			left-arrow
			@click-left="onClickLeft"
		/>
		<!--        @click-left="onClickLeft"-->
		<!--        @click-right="onClickRight"-->
		<div class="content">
			<div class="item">
				<!--        <div class="list-item">-->
				<!--          <div class="item-title">-->
				<!--            所属客服-->
				<!--          </div>-->
				<!--          <div @click="$refs.employee.$show(StandbyStaffList,'max')" class="item-content">-->

				<!--            {{ StandbyStaffList.length > 0 ? String(StandbyStaff) : '请选择客服' }}-->
				<!--            <van-icon name="arrow-down"/>-->
				<!--          </div>-->
				<!--        </div>-->

<!--				<div class="list-item">
					<div class="item-title">
						企业标签
					</div>
					<div @click="$refs.tags.$show(tagsList)" style="margin-top: var(&#45;&#45;base-px-10);">
						<van-button @click="" style="height: var(&#45;&#45;base-px-30);" plain type="info">选择标签</van-button>
					</div>
					<div v-if="tagsList.length > 0" style="margin-top: var(&#45;&#45;base-px-10);">
						<van-tag style="margin: 0 var(&#45;&#45;base-px-5)" v-for="(item,index) in tagsList" closeable plain size="medium"
						         type="primary"
						         @close="tagsList.splice(index,1)">{{ item.name }}
						</van-tag>
					</div>
				</div>
				<div class="list-item">
					<div class="item-title">
						添加时间
					</div>
					<div class="item-content" @click="$refs.time.$show()">
						<div @click="$refs.time.$show()" style="flex: 1;text-align: center">
							{{ sTime ? sTime : '开始时间' }}
						</div>
						-
						<div @click="$refs.time.$show()" style="flex: 1;text-align: center">
							{{ endTime ? endTime : '结束时间' }}
						</div>
					</div>
				</div>-->

				<!--        <div class="list-item">-->
				<!--          <div class="item-title">-->
				<!--            添加渠道-->
				<!--          </div>-->
				<!--          <div>-->
				<!--            <div v-for="(item,index) in qcode" :key="index" @click="activeq(index)" :class="{qd: item.chose}" class="item-content item-lable">-->
				<!--              {{ item.name }}-->
				<!--            </div>-->
				<!--          </div>-->
				<!--        </div>-->

<!--				<div class="list-item">
					<div class="item-title">
						客户性别
					</div>
					<div>
						<div @click="codew = 0" :class="{qd: codew == 0}" class="item-content item-lable"
						     style="padding: 0 var(&#45;&#45;base-px-26);">
							全部
						</div>
						<div @click="codew = 1" :class="{qd: codew == 1}" class="item-content item-lable"
						     style="padding: 0 var(&#45;&#45;base-px-26);">
							男
						</div>
						<div @click="codew = 2" :class="{qd: codew == 2}" class="item-content item-lable"
						     style="padding: 0 var(&#45;&#45;base-px-26);">
							女
						</div>
					</div>
				</div>
				<div class="list-item">
					<div class="item-title">
						流失状态
					</div>
					<div>
						<div @click="lose = 0" :class="{qd: lose == 0}" class="item-content item-lable">
							全部
						</div>
						<div @click="lose = 1" :class="{qd: lose == 1}" class="item-content item-lable">
							未流失
						</div>
						<div @click="lose = 2" :class="{qd: lose == 2}" class="item-content item-lable">
							已流失
						</div>
					</div>
				</div>-->
				<div class="list-item">
					<div class="item-title">
						注册时间
					</div>
					<div class="item-content" @click="$refs.time1.$show()">
						<div @click="$refs.time1.$show()" style="flex: 1;text-align: center">{{
								regSTime ? regSTime : '开始时间'
							}}
						</div>
						-
						<div @click="$refs.time1.$show()" style="flex: 1;text-align: center">{{
								regETime ? regETime : '结束时间'
							}}
						</div>
					</div>
				</div>
				<div class="list-item">
					<div class="item-title">
						看课
					</div>
					<div>
						<div @click="seeClass = -1" :class="{qd: seeClass === -1}" class="item-content item-lable">
							全部
						</div>
						<div @click="seeClass = 0" :class="{qd: seeClass === 0}" class="item-content item-lable">
							今日未观看
						</div>
						<div @click="seeClass = 1" :class="{qd: seeClass === 1}" class="item-content item-lable">
							今日未完播
						</div>
						<div @click="seeClass = 2" :class="{qd: seeClass === 2}" class="item-content item-lable">
							今日已完播
						</div>
					</div>
				</div>
<!--				<div class="list-item">
					<div class="item-title">
						是否注册
					</div>
					<div>
						<div @click="isRegister = -1" :class="{qd: isRegister === -1}" class="item-content item-lable">
							全部
						</div>
						<div @click="isRegister = 1" :class="{qd: isRegister === 1}" class="item-content item-lable">
							已注册
						</div>
						<div @click="isRegister = 0" :class="{qd: isRegister == 0}" class="item-content item-lable">
							未注册
						</div>
					</div>
				</div>-->
				<div style="    justify-content: space-around;
    width: 100%;display: flex;    justify-content: space-between;">
					<van-button @click="onClickLeft"
					            style="width: 45%;border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8) var(--base-px-8);"
					            block type="default">
						取消
					</van-button>
					<van-button @click="customer"
					            style="width: 45%;border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8) var(--base-px-8);"
					            block type="info">确定
					</van-button>
				</div>
			</div>

		</div>
		<!--  选择客户  -->
		<addCustomer ref="customer"/>
		<!--  选择标签  -->
		<addTags ref="tags" @change="tagsChose"/>
		<!--  时间选择  -->
		<addTime ref="time" @change="choseTime"/>
		<!--  时间选择  -->
		<addTime ref="time1" @change="choseTime1"/>
		<employeeIndex ref="employee" @change="userChange"/>
	</div>
</template>

<script>
import addCustomer from "../index/components/addCustomer";
import addTags from "../channelCode/components/customerLabel";
import employeeIndex from "../channelCode/components/employeeIndex";
import addTime from "../channelCode/components/addTime";

export default {
	components: {
		addCustomer,
		addTags,
		addTime,
		employeeIndex
	},
	data() {
		return {
			// 文字
			message: '',
			// tbas切换
			tabsChose: 0,
			// 员工
			StandbyStaffList: [],
			StandbyStaff: [],
			tagsList: [],
			sTime: '',
			endTime: '',
			//渠道
			qcode: [{chose: true, addWay: 2, name: '搜索手机号'}, {
				chose: false,
				addWay: 5,
				name: '手机通讯录'
			}, {chose: false, addWay: 8, name: '安装第三方应用时添加的客服人员'}, {
				chose: false,
				addWay: 202,
				name: '管理员/负责人分配'
			}, {chose: false, addWay: 1003, name: '裂变引流'}],
			// 性别
			codew: 0,
			lose: 0,
			regSTime: '',
			regETime: '',
			seeClass: -1,
			isRegister: -1
		}
	},
	created() {
		if (this.$route.query.content) {
			const query = JSON.parse(this.$route.query.content)
			this.tagsList = query.tagss || ''
			this.codew = query.gender ?? 0
			this.sTime = query.startTime || ''
			this.endTime = query.endTime || ''
			this.regETime = query.end_registration_time || ''
			this.regSTime = query.start_registration_time || ''
			this.lose = query.status ?? 0
			this.seeClass = query.watchLessonStatus ?? -1
			this.isRegister = query.isRegister ?? -1
		}
	},
	methods: {
		onClickLeft() {
			this.$router.push({
				path: "/contact/index"
			})
		},
		// 员工
		userChange(data, info) {
			this.StandbyStaffList = data
			this.StandbyStaff = data.map(i => i.name)
		},
		tagsChose(data) {
			this.tagsList = data
		},
		choseTime(data) {
			if (data) {
				this.sTime = data.time.split("|")[0]
				this.endTime = data.time.split("|")[1]
			} else {
				this.sTime = ''
				this.endTime = ''
			}
		},
		choseTime1(data) {
			if (data) {
				this.regSTime = data.time.split("|")[0]
				this.regETime = data.time.split("|")[1]
			} else {
				this.regSTime = ''
				this.regETime = ''
			}

		},
		activeq(i) {
			this.qcode.forEach(i => {
				return i.chose = false
			})
			this.qcode[i].chose = true
		},
		customer() {
			// let tags = ''
			// this.tagsList.forEach(item => {
			// 	tags += item.id + ','
			// })
			// tags = tags.slice(0, tags.length - 1)
			const content = {
				tags: this.tagsList,
				gender: this.codew,
				startTime: this.sTime,
				endTime: this.endTime,
				end_registration_time: this.regETime,
				start_registration_time: this.regSTime,
				status: this.lose,
				watchLessonStatus: this.seeClass,
				isRegister: this.isRegister,
			}
			this.$router.push({
				path: "/contact/index",
				query: {
					content: JSON.stringify(content)
				}
			})
		},
	}
}
</script>

<style lang="less" scoped>
/deep/ .van-nav-bar__content {
	background: #2b63cd;
	color: #fff;
}

/deep/ .van-nav-bar .van-icon {
	color: #fff;
}

/deep/ .van-nav-bar__text {
	color: #fff;
}

/deep/ .van-nav-bar__title {
	color: #fff;
}

.index {
	font-size: var(--base-px-14);
	height: 100%;
	background: #F1f2f5;

	p {
		margin: 0 !important;
	}

	.qd {
		color: #1890ff !important;
		border-color: #1890ff !important;
		background-color: #f3f9ff !important;
	}

	.content {
		height: 92%;

		img {
			width: var(--base-px-22);
			height: var(--base-px-22);
		}

		padding: var(--base-px-16) var(--base-px-12);

		.item {
			background: #fff;
			padding: var(--base-px-20) var(--base-px-15);
			height: 100%;
			overflow: auto;
			padding-bottom: var(--base-px-20);

			.list-item {
				margin-bottom: var(--base-px-10);
			}

			.item-title {
				font-weight: bold;
			}

			.item-content {
				width: 100%;
				/* background: red; */
				border: var(--base-px-1) solid #E5E6E7;
				height: var(--base-px-36);
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0 var(--base-px-10);
				border-radius: var(--base-px-7);
				margin-top: var(--base-px-10);
			}

			.item-lable {
				display: inline-block;
				width: auto;
				align-items: center;
				line-height: var(--base-px-36);
				margin: var(--base-px-10) var(--base-px-3);
				border-radius: 0;
			}
		}
	}

	.bottom-button {
		display: flex;
		align-items: center;
		position: fixed;
		bottom: var(--base-px-20);
		justify-content: space-around;
		width: 100%;
	}
}
</style>
